"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var MenuItem_1 = __importDefault(require("shared/components/DropdownMenu/MenuItem"));
var SettingsMenuItem = (0, styles_1.styled)(MenuItem_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        '&.Mui-selected': {
            margin: theme.spacing(0.5, 0.125),
            backgroundColor: theme.palette.common.white,
            '& .MuiTypography-body1 ': {
                fontWeight: theme.typography.fontWeightMedium,
            },
            '& .MuiTypography-caption': {
                color: theme.palette.text.secondary,
            },
            '&:hover': {
                backgroundColor: theme.palette.secondary.light,
            },
            ':focus-visible': {
                margin: theme.spacing(0.5, 0.75),
            },
        },
    });
});
exports.default = SettingsMenuItem;
